import { useMutation } from "react-query";
import { axiosPost } from "../../lib/axiosClient";

const useDeleteSelftest = () => {
  return useMutation((id) => {
    return axiosPost("/api/cw/deleteSelfTest", id);
  });
};

export default useDeleteSelftest;
